const thng = (id) => window.evrythngToken.thng(id);

const thngApi = {
	scan: (id) => thng(id).action('implicitScans').create(),
	get: (id) => thng(id).read(),
};

export default thngApi;
